export default "__VITE_ASSET__Cl_fP6nd__"